class ProductCart extends HTMLElement {
  constructor() {
    super();
    this.addProductButton = this.querySelector('button.cart-add-button');
    this.setupEventListeners();
    this.body = document.querySelector('body');
  }

  setupEventListeners() {
    this.addProductButton.addEventListener('click', () => {
      var productId = this.addProductButton.dataset.productid;
      this.addProductToCart(productId);
    });
  }

  addProductToCart(id) {
    let data = {
      'id': id,
      'quantity': 1
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        return response.json();
      }).then(product => {
        fetch(window.Shopify.routes.root + 'cart.js', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          },
        }).then(response => {
          return response.json();
        }).then((cart) => {
          
          var cartRoute = theme.routes.cart_url;
          var buttonName = theme.strings.addedToCartPopupGoToCart;
          var closeButtonLabel = theme.strings.close;
          var closeButton = theme.icons.close;
          var cartTitle = theme.strings.addedToCartPopupTitle;
          var footerTitle = theme.strings.addedToCartPopupItems;
          var subTotal = theme.strings.addedToCartPopupSubtotal;
          var html =
            `
            <div class="added-notice__header">
                <span class="added-notice__title">${cartTitle}</span>
                <a class="added-notice__close feather-icon" href="" aria-label="${closeButtonLabel}">
                    ${closeButton}
                </a>
            </div>
            <div class="cart-summary global-border-radius">
                <div class="cart-summary__product">
                    <div class="cart-summary__product-image"><img class="global-border-radius" src="${product.image}"
                            role="presentation" alt=""></div>
                    <div class="cart-summary__product__description">
                        <div class="cart-summary__product-title">
                            ${product.title}
                            <span class="cart-summary__quantity">${product.quantity}</span>
                        </div>
                        <div class="cart-summary__price">${theme.Shopify.formatMoney(product.price,theme.moneyFormatWithCodeForCartPreference)}</div>
                    </div>
                </div>
            </div>
            <div class="cart-summary__footer">
                <div class="cart-summary__total-quantity-row">
                    <span>${footerTitle}</span>
                    <span>${cart.item_count}</span>
                </div>
                <div class="cart-summary__total-price-row large-text">
                    <span>${subTotal}</span>
                    <span>${theme.Shopify.formatMoney(cart.total_price, theme.moneyFormatWithCodeForCartPreference)}</span>
                </div>
                <a href="${cartRoute}" class="btn btn--primary btn--small btn--fullwidth cart-summary__button">${buttonName}</a>
            </div>`

          const notificationWrapper = document.createElement('div');
          notificationWrapper.id = 'notification-window';
          notificationWrapper.classList.add('added-notice', 'global-border-radius', 'added-notice--pre-reveal');
          notificationWrapper.innerHTML = html;
          this.body.appendChild(notificationWrapper);
          setTimeout(() => { notificationWrapper.classList.remove('added-notice--pre-reveal') }, 10);
          setTimeout(() => { notificationWrapper.remove() }, 5000);
          document.querySelectorAll(".header-cart__count").forEach(item => item.innerHTML = cart.item_count);


          notificationWrapper.querySelector('.added-notice__close').addEventListener('click', (e) => {
            e.preventDefault();
            notificationWrapper.classList.add('added-notice--pre-destroy');
            setTimeout(() => { notificationWrapper.remove() }, 500);
          })
        })
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

}
customElements.define('product-cart', ProductCart);